<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import "./ol.css";

$searchbox_height: 4.85em; // = 64px (body font size =?)
$searchbox_height_16px: 4em; // = 64px (body font size =16px)
$button_size_14px: 3em; // = 42px (body font size = 14px)
$button_size_20px: 2.1em; // = 42px (body font size = 20px)


.screencontainer {
  width: 100%;
  height: 100%;
}

.searchBox {
  // .v-input font-size: 16px; (= body font size)
  padding-left: 17px;
  padding-right: 17px;
  height: $searchbox_height_16px; // = 64px
  top: 15px;
}

.ol-control:hover {
  background-color: rgba(0, 0, 0, 0);
}

.ol-control {
  font-size: 18px;

  button {
    background-color: rgba(245, 245, 245, 1);
    color: black;
    font-weight: normal;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    transition-property: box-shadow, transform, opacity, -webkit-box-shadow, -webkit-transform;
    border-radius: 4px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  button:hover {
    background-color: rgba(245, 245, 245, 1);
    color: black;
  }

  button:focus {
    background-color: rgba(245, 245, 245, 1);
    color: black;
  }
}

.ol-zoom {
  top: $button_size_20px/2; // = 1.05em = 21px
  left: unset !important;
  right: 0.5em;
  background-color: rgba(255, 255, 255, 0);


  .ol-zoom-in {
    height: 42px;
    width: 42px;
    min-width: 42px;
    color: rgba(0, 0, 0, 0.87);
    border-radius: 4px;
  }

  .ol-zoom-out {
    height: 42px;
    width: 42px;
    min-width: 42px;
    color: rgba(0, 0, 0, 0.87);
    border-radius: 4px;
  }
}

/*
.layer-switcher-popup {
  z-index: 10;
  top: 1*$searchbox_height+4*$button_size;
  button {
    width: 0; //$button_size;
    height: 0;  //$button_size;
    font-size: $button_size -($button_size/8); // = 1.4em
    background-position-x: center;
    background-position-y: center;
  }
  ul {
    line-height: 2;
  }
  li.layer input {
    vertical-align: unset; //alignement checkbox avec texte
  }
  input[type=checkbox] {
    transform: scale(1.5);
  }
}
*/

.layer-switcher-dialog {
  // min-height: 350px;
  max-width: 220px;
}

.mapdiv {
  width: 100%;
  height: 100%;
}

.layers_button {
  // .v-btn.v-size--default font-size: 0.875rem = 14px (= body font size)
  margin-right: -0.3em; // -4px
  top: $searchbox_height + (3*$button_size_14px) + 0.2; // 197px
}

ul {
  list-style: none;
}

li {
  padding-top: 0.5em;
  padding-left: 0.1em;
  text-indent: -1.5em;

}

label {
  padding-left: 5px;
  vertical-align: bottom;
}

.gps_button {
  // .v-btn.v-size--default font-size: 0.875rem = 14px (= body font size)
  margin-right: -0.3em; // -4px
  top: $searchbox_height + (4.5*$button_size_14px) + 0.2; // 260px
}

.ol-attribution {
  bottom: 1em;
  margin-right: 0.15em; // 3px
  font-size: 0.8em;
  position: fixed;
  background-color: rgba(255, 255, 255, 0);
}

//wrap text results in info window
.v-list-item__title {
  white-space: normal;
}

</style>

<template>
  <div ref="screencontainer" class="screencontainer">
    <template v-if="showSearchBox">
      <v-autocomplete
        v-model="model"
        :clearable="clearable"
        :items="items"
        :label=autoCompleteMsg
        :loading="isLoading"
        :search-input.sync="search"
        append-icon="search"
        aria-label="recherche adresse"
        chips
        class="searchBox"
        color="indigo lighten-1"
        dense
        hide-no-data
        item-text="label"
        item-value="id"
        return-object
        @change="gotoSelectedAdr"
        @click:clear="clearItems"
      ></v-autocomplete>
    </template>

    <template v-if="gpsBlockedByUser">
      <v-snackbar
        :multi-line="true"
        :timeout="10000"
        :value="noGpsErrorMessage"
        color="error"
        top
      >
        ERREUR : Vous avez refusé de partager votre position GPS, le tracking ne fonctionnera pas !
        <v-btn
          icon
          @click="noGpsErrorMessage = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </template>

    <!-- TEST RENDU LAYERSWITCHER PERSONALISE -->
    <div class="text-xs-center">
      <v-dialog v-model="layerSwitcherVisible" eager width="300">
        <v-card>
          <v-card-title class="subtitle-1 grey lighten-2 pl-6 pt-2 pb-1" primary-title>
            Choix des couches
          </v-card-title>

          <v-card-text>
            <div id="divLayerSwitcher" ref="divLayerSwitcherContent" class="layer-switcher-dialog">
              <!--
              liste des couches de la carte
              <ul>
                <li class="layer"><input type="checkbox" id="61796301-585e-42ff-9cdc-df8029c843d8">
                  <label for="61796301-585e-42ff-9cdc-df8029c843d8">Limites communales</label></li>
                <li class="layer"><input type="checkbox" id="b11b5c35-406d-4860-86c8-464c616d76b8">
                  <label for="b11b5c35-406d-4860-86c8-464c616d76b8">Limites des
                    constructions</label></li>
                <li class="layer"><input type="radio" name="base"
                                         id="de0a785e-56ec-4252-bbd0-e8d196550e42"><label
                  for="de0a785e-56ec-4252-bbd0-e8d196550e42">Orthophoto 2016</label></li>
                <li class="layer"><input type="radio" name="base"
                                         id="f53ad9f1-1a8a-4e38-9bc9-899635294e53"><label
                  for="f53ad9f1-1a8a-4e38-9bc9-899635294e53">Plan cadastral</label></li>
                <li class="layer"><input type="radio" name="base"
                                         id="1afb57dd-ac06-4da9-b374-7baf4ad62dc1"><label
                  for="1afb57dd-ac06-4da9-b374-7baf4ad62dc1">Plan ville couleur</label></li>
              </ul>
              -->
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-1">
            <v-spacer></v-spacer>
            <v-btn
              class="caption white--text"
              color="indigo lighten-1"
              height="25"

              @click="layerSwitcherVisible = false"
            >
              Fermer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div ref="mymap" class="mapdiv">
    </div>

    <v-btn
      absolute
      aria-label="selection couches"
      class="layers_button"
      height="42"
      min-width="42"
      right
      width="42"
      @click.stop="toggleLayerSwitcher"
    >
      <v-icon size="28">mdi-layers-outline</v-icon>
    </v-btn>

    <template v-if="!gpsBlockedByUser">
      <v-btn
        absolute
        aria-label="activer geolocalisation"
        class="gps_button"
        height="42"
        min-width="42"
        right
        width="42"
        @click.stop="toggleGpsTracking"
      >
        <template v-if="gpsTrackingEnabled">
          <v-icon dark>gps_fixed</v-icon>
        </template>
        <template v-else>
          <v-icon>gps_off</v-icon>
        </template>
      </v-btn>
    </template>

    <v-bottom-sheet v-model="displayInfo" :hide-overlay="true" inset max-width="80%">
      <template v-slot:activator>
      </template>
      <v-toolbar color="indigo lighten-1" dark dense flat height="30">
        <v-toolbar-title class="body-1 font-weight-medium">Informations trouvées</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="displayInfo=false">
          <v-icon>highlight_off</v-icon>
        </v-btn>
      </v-toolbar>

      <v-list>
        <v-list-item-title
          v-for="item in infoList"
          :key="item.title"
          @click="displayInfo = false"
        >
          <template v-if="item.url.length >0">
            <v-list-item-title class="body-2 py-1 pl-2">
              <a :href="item.url" target="_blank"> {{ item.title | convertEntitiesInText }}</a>
            </v-list-item-title>
          </template>
          <template v-else>
            <v-list-item-title class="body-2 py-1 pl-2" dense>
              {{ item.title | convertEntitiesInText }}
            </v-list-item-title>
          </template>
        </v-list-item-title>
      </v-list>
    </v-bottom-sheet>


  </div>
</template>

<script>
import {
  isNullOrUndefined, functionExist, getEl,
  getFloatParam, getIntegerParam,
} from 'cgil-html-utils';
import axios from 'axios';
import Geolocation from 'ol/Geolocation';
import OlFeature from 'ol/Feature';
import OlPoint from 'ol/geom/Point';
import OlCircleGeom from 'ol/geom/Circle';
import OlLayerVector from 'ol/layer/Vector';
import OlSourceVector from 'ol/source/Vector';
import OlFill from 'ol/style/Fill';
import OlCircle from 'ol/style/Circle';
import OlStroke from 'ol/style/Stroke';
import OlStyle from 'ol/style/Style';
import OlStyleIcon from 'ol/style/Icon';
import LayerSwitcher from 'ol-layerswitcher';
import { getLog, BASE_REST_API_URL } from '../config';
import {
  createLausanneMap,
  Conv4326In2056,
  getLayerByName,
  getVectorSourceGeoJson,
  getPolygonStyle, isItMN03, Conv21781In2056, // Conv2056In21781,
} from './ol-lausanne-map-mn95';
import limiteLausanne from './geodata/limite_lausanne';
// import { createLausanneMap, Conv4326In21781 } from './ol-lausanne-map';

const TopBarHeight = 66;
const MODULE_NAME = 'olmap';
const log = getLog(MODULE_NAME, 4, 4);
// const coordPfa3180Stfrancois = [538224.21, 152378.17]; // PFA3 180 - St-Francois
// migrate to MN95
const coordPfa3180Stfrancois = [2538223.802, 1152378.590]; // PFA3 180 - St-Francois


// http://localhost:8080/?lon=6.62645&lat=46.50677&z=17  // zoom sur Ouchy,Lausanne Suisse
const lonUrl = getFloatParam('lon', coordPfa3180Stfrancois[0]);
const latUrl = getFloatParam('lat', coordPfa3180Stfrancois[1]);
const zoomUrl = getIntegerParam('z', 3);

function hideVirtualKeyboard() {
  if (
    document.activeElement
    && document.activeElement.blur
    && typeof document.activeElement.blur === 'function'
  ) {
    document.activeElement.blur();
  }
}

// const autoCompleteMsgByDefault = 'Commencez à taper pour rechercher...';
const autoCompleteMsgByDefault = 'Recherche d\'adresse ou de parcelle...';
const convertEnt = (text) => {
  if (isNullOrUndefined(text)) return '';
  let textFiltered = `${text}`.trim();
  textFiltered = textFiltered.replace(/&#39;/g, '\'');
  textFiltered = textFiltered.replace('&amp;', '&');
  textFiltered = (`${textFiltered}`).replace(/&#\d+;/gm, s => String.fromCharCode(
    s.match(/\d+/gm)[0],
  ));
  // log.w(`## IN convertEnt : textFiltered : ${textFiltered}`, textFiltered);
  return textFiltered;
};
const createIconStyleCenterCenter = imagePath => new OlStyle({
  image: new OlStyleIcon({ // http://openlayers.org/en/latest/apidoc/ol.style.Icon.html
    src: imagePath,
    opacity: 1.0,
    anchor: [0.5, 0.5], // we want the marker to be centered
  }),
});

export default {
  name: 'olMap',
  data() {
    return {
      olmap: null,
      zoom: zoomUrl,
      center: [lonUrl, latUrl],
      olGeoLocation: null,
      olGeolocationMapLayer: null,
      gpsTrackingEnabled: false,
      gpsTrackingCounter: 0,
      gpsBlockedByUser: false,
      noGpsErrorMessage: true,
      displayInfo: false,
      layerSwitcherVisible: false,
      overlay: false,
      autoCompleteMsg: autoCompleteMsgByDefault,
      infoList: [
        {
          title: 'Mes belles informations ...',
          url: '',
        },
        {
          title: 'Des autres informations',
          url: '',
        },
      ],
      queryLayer: null,
      searchResultLayer: null,
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      clearable: false,
      showSearchBox: true,
    };
  },
  props: {
    extent: {
      type: Array,
      default: null,
    },
    displayPoint: {
      type: Boolean,
      default: false,
    },
    layersconfig: null,
  },
  computed: {
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model)
        .map(key => ({
          key,
          value: this.model[key] || 'n/a',
        }));
    },
    items() {
      return this.entries.map((entry) => {
        const label = entry.label.length > this.descriptionLimit
          ? `${entry.label.slice(0, this.descriptionLimit)}...`
          : entry.label;

        return Object.assign({}, entry, { label });
      });
    },
  },

  watch: {
    search(val, oldval) {
      log.l(`watch-search(val=${val}, oldval= ${oldval})`);
      this.clearable = true; // done here to allow lighthouse 100% success on accessibility
      this.gpsTrackingEnabled = false;
      this.olGeoLocation.setTracking(false);
      if (isNullOrUndefined(val)) return;
      if (val.length < 3) return;
      // Items have already been loaded
      // if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;

      // Lazily load input items
      fetch(`${BASE_REST_API_URL}/adresses/search_position?ofs=0&query=${val}`)
        .then(res => res.json())
        .then((res) => {
          this.entries = res;
        })
        .catch((err) => {
          log.e(`ERROR in watch-search(val=${val})`, err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  filters: {
    limitTextSize(text, maxSize = 100) {
      if (isNullOrUndefined(text)) return '';
      if (text.length < maxSize) return text;
      return `${text.substring(0, maxSize)}…`;
    },
    convertEntitiesInText(text) {
      return convertEnt(text);
    },
  },
  mounted() {
    log.l('mounted()');
    this.olmap = createLausanneMap(
      this.$refs.mymap,
      this.center,
      this.zoom,
      'divLayerSwitcher',
      this.extent,
      this.displayPoint,
      this.layersconfig,
      (pCoordInfo) => {
        log.l('in mounted click callback pCoordInfo :', pCoordInfo);
        // callParentCode(pCoordInfo);
        this.$emit('pointclick', pCoordInfo);
      },
    )
      .then((OMap) => {
        this.olmap = OMap;
        log.l('this.olmap :', this.olmap);
        // loadWMSLayers(this.olmap , layersconfig);
        this.loadLayerLimiteLausanne();

        /* done already in createMap
        if (!isNullOrUndefined(this.layersconfig.baseLayer)) {
          this.setBaseLayer(this.layersconfig.baseLayer);
        }
        */

        // begin code to implement url position update
        const state = {
          pos: this.center,
          z: this.zoom,
        };
        window.history.pushState(state, '', '');
        const v = this.olmap.getView();
        v.addEventListener('change:center', (e) => {
          const pos = e.target.getCenter()
            .map(x => x.toFixed(2));
          const z = e.target.getZoom()
            .toFixed(0);
          const newUrlParam = `?lon=${pos[0]}&lat=${pos[1]}&z=${z}`;
          window.history.replaceState(state, '', newUrlParam);
          log.w(`Event change:center () ${newUrlParam}`);
        });
        // end of code to implement url position update

        const layerForQuery = this.olmap.VDL_layerForQuery;
        this.prepareGeolocation(this.gpsTrackingEnabled);
        // const egliseStfrancois = new OlFeature(new OlPoint(coordPfa3180Stfrancois));
        // egliseStfrancois.setStyle(createIconStyleCenterCenter('icone_blue.png'));
        this.queryLayer = new OlLayerVector({
          source: new OlSourceVector({
            features: [],
          }),
        });
        // this.olmap.addLayer(this.queryLayer);
        this.queryLayer.getSource().clear();
        this.searchResultLayer = new OlLayerVector({
          source: new OlSourceVector({
            features: [],
          }),
        });
        // this.olmap.addLayer(this.searchResultLayer);
        this.searchResultLayer.getSource()
          .clear();

        this.olmap.on(
          'click',
          (evt) => {
            const x = Number(evt.coordinate[0])
              .toFixed(2);
            const y = Number(evt.coordinate[1])
              .toFixed(2);
            log.t(`#in olmap.click at x,y ${x}, ${y}`);
            if (this.layerSwitcherVisible) {
              log.w('#in olmap.click will hide layerswitcher');
              this.layerSwitcherVisible = false;
              // this.olmap.myref2LayerSwitcher.hidePanel();
            } else {
              this.queryLayer.getSource()
                .clear();
              const newPlace = new OlFeature(new OlPoint([x, y]));
              newPlace.setStyle(createIconStyleCenterCenter('clic_point.png'));
              this.queryLayer.getSource()
                .addFeature(newPlace);
              // WMS
              const sourceWMS = layerForQuery.getSource();
              const viewResolution = (this.olmap.getView()
                .getResolution());
              // alternate format : { INFO_FORMAT: 'application/vnd.ogc.gml' }
              // WARNING : migration sur OL6 => getGetFeatureInfoUrl deviendra getFeatureInfoUrl
              // const urlWms = sourceWMS.getFeatureInfoUrl([+x, +y], viewResolution, 'EPSG:21781'
              // , { INFO_FORMAT: 'application/geojson' });
              // TODO: CONVERT X;Y TO 21781
              // const posMN03 = Conv2056In21781(+x,+y);
              // const urlWms = sourceWMS.getFeatureInfoUrl(posMN03,
              // viewResolution, 'EPSG:21781', { INFO_FORMAT: 'application/geojson' });
              const urlWms = sourceWMS.getFeatureInfoUrl([+x, +y], viewResolution, 'EPSG:2056', { INFO_FORMAT: 'application/geojson' });
              log.t(`## BEGIN GoMap click callback : ${x},${y}
              urlWMS = ${urlWms}`, viewResolution, sourceWMS);
              axios.get(urlWms)
                .then((response) => {
                  // handle success
                  log.l('SUCCESS in WMS GetFeatureInfo Callback', response);
                  const { data } = response;
                  log.l('data :', data);
                  const arrLayersInfo = data.split('####END_OF_LAYER####')
                    .filter(e => e.length > 1)
                    .map(e => JSON.parse(e));
                  log.w('arrLayersInfo', arrLayersInfo);
                  if (arrLayersInfo.length > 0) {
                    const info = arrLayersInfo[0].features[0].properties.type;
                    log.w(`INFO:${info}`);
                    // filtrage du tableau de reponse en fonction de la visibilite
                    // this.getVisibleLayers();
                    const arrFiltered = arrLayersInfo.filter((item) => {
                      log.w('item', item);
                      const val = item.features[0].properties.type;
                      const arrValues = val.split(',')
                        .filter(i => i.trim().length > 0);
                      return arrValues.length > 0;
                    });
                    log.w('arrFiltered', arrFiltered);
                    this.infoList = arrFiltered.map((layer) => {
                      const linfo = layer.features[0].properties.type
                        .split(',')
                        .filter(i => i.trim().length > 0)
                        .join(',');
                      let result = {
                        title: linfo,
                        url: '',
                      };
                      const { url } = layer.features[0].properties;
                      if (!isNullOrUndefined(url)) {
                        log.w(`URL:${url}`);
                        result = {
                          title: linfo,
                          url,
                        };
                      }
                      return result;
                    });
                    this.displayInfo = true;
                  }
                })
                .catch((error) => {
                  // handle error
                  log.e('ERROR in WMS GetFeatureInfo Callback', error);
                })
                .finally(() => {
                  log.l('END of AXIOS GET WMS GetFeatureInfo Callback');
                });
            }
          },
        );
        /*
    this.updateSize();
    window.onresize = () => {
      this.updateSize();
    };
    */
      });
  },
  methods: {
    updateSize() {
      const divMap = this.$refs.mymap;
      const divContainer = this.$refs.screencontainer;
      divMap.style.height = `${divContainer.clientHeight - TopBarHeight}px`;
      log.l(`##onresize container WxH: ${divContainer.clientWidth} x ${divContainer.clientHeight}`);
      // log.l(`##onresize mymap     WxH: ${divMap.clientWidth} x ${divMap.clientHeight}`);
      this.olmap.updateSize();
    },
    updatePosition(geolocationRef, posFeatureRef, accuracyFeatureRef) {
      const coordinates = geolocationRef.getPosition();
      // const P21781 = Conv4326In21781(coordinates[0], coordinates[1]);
      let P2056 = null;
      if (+coordinates[0] > 580000) {
        // suppose we are already in  MN95
        log.l(`${coordinates[0]} > 580000`);
        P2056 = [+coordinates[0], +coordinates[1]];
      } else {
        // conversion en MN95
        P2056 = Conv4326In2056(coordinates[0], coordinates[1]);
      }
      const accuracy = geolocationRef.getAccuracy();
      log.l(`geolocation updatePosition Lon/Lat: ${coordinates[0]},${coordinates[1]} accuracy:${accuracy}`);
      log.l(`geolocation updatePosition MN95: ${P2056[0]},${P2056[1]} accuracy:${accuracy}`);
      const currentPosition = [P2056[0], P2056[1]];
      const currentPointPosition = new OlPoint(currentPosition);
      posFeatureRef.setGeometry(currentPointPosition);
      accuracyFeatureRef.setGeometry(new OlCircleGeom(currentPosition, accuracy));
      this.olmap.getView()
        .setCenter(currentPosition);
      if (this.gpsTrackingCounter < 2) {
        this.olmap.getView()
          .setZoom(8);
        this.gpsTrackingCounter += 1;
      }
    },
    prepareGeolocation(enableGeoLocation) {
      // geolocation stuff so the map follow device pos

      const positionFeature = new OlFeature();
      positionFeature.setStyle(new OlStyle({
        image: new OlCircle({
          radius: 6,
          fill: new OlFill({
            color: '#3399CC',
          }),
          stroke: new OlStroke({
            color: '#fff',
            width: 2,
          }),
        }),
      }));
      const accuracyFeature = new OlFeature();

      const geolocationLayer = new OlLayerVector({
        map: this.olmap,
        source: new OlSourceVector({
          features: [accuracyFeature, positionFeature],
        }),
      });
      // this.olmap.addLayer(geolocationLayer);
      this.olGeolocationMapLayer = geolocationLayer;

      const geolocation = new Geolocation({
        // enableHighAccuracy must be set to true to have the heading value.
        trackingOptions: {
          enableHighAccuracy: true,
        },
        projection: this.olmap.getView()
          .getProjection(),
      });
      this.olGeoLocation = geolocation;
      geolocation.setTracking(enableGeoLocation);


      // update the HTML page when the geolocation information changes.
      geolocation.on('change', () => {
        log.t(`geolocation.on('change' Accuracy: ${geolocation.getAccuracy()}`);
        this.updatePosition(geolocation, positionFeature, accuracyFeature);
        // geolocationChangeCallback(geolocation);
      });

      geolocation.on('error', (error) => {
        log.e(`geolocation ERROR : ${error.message}`);
        this.gpsBlockedByUser = true;
      });

      geolocation.on('change:accuracyGeometry', () => {
        log.t(`geolocation.on('change:accuracyGeometry' Accuracy: ${geolocation.getAccuracy()}`);
        this.updatePosition(geolocation, positionFeature, accuracyFeature);
      });

      geolocation.on('change:position', () => {
        log.t(`geolocation.on('change:position' Accuracy: ${geolocation.getAccuracy()}`);
        this.updatePosition(geolocation, positionFeature, accuracyFeature);
      });
    },
    centerMap(arrCoordPos, zoomLevel = 9) {
      if (!isNullOrUndefined(arrCoordPos)) {
        log.t(`centerMap x,y = (${arrCoordPos[0]},${arrCoordPos[1]}) zoom = ${zoomLevel}`);
        if (isItMN03(arrCoordPos)) {
          const pointMN95 = Conv21781In2056(arrCoordPos[0], arrCoordPos[1]);
          this.olmap.getView()
            .setCenter(pointMN95);
        } else {
          this.olmap.getView()
            .setCenter(arrCoordPos);
        }
        this.olmap.getView()
          .setZoom(zoomLevel);
      }
    },
    gotoSelectedAdr(objSelected) {
      log.t('# gotoSelectedAdr', objSelected);
      if (!isNullOrUndefined(objSelected)) {
        // this.arrSelectionsAdresse.push(objSelected)
        if (!isNullOrUndefined(objSelected.id)) {
          const arrCoords = objSelected.id.split('_');
          const newPos = [Number.parseFloat(arrCoords[0]), Number.parseFloat(
            arrCoords[1],
          )];
          this.centerMap(newPos, 8);
          this.searchResultLayer.getSource()
            .clear(); // pour effacer ancienne recherche
          const newPlace = new OlFeature(new OlPoint(newPos));
          newPlace.setStyle(createIconStyleCenterCenter('search_result.png'));
          this.searchResultLayer.getSource()
            .addFeature(newPlace);
          hideVirtualKeyboard();
          // pour essayer de fermer le clavier virtuel
          this.$refs.mymap.focus();
        }
      }
    },
    toggleGpsTracking() {
      log.t(`# toggleGpsTracking this.gpsTrackingEnabled : ${this.gpsTrackingEnabled}`);
      if (this.gpsTrackingEnabled) {
        this.gpsTrackingEnabled = false;
        this.gpsTrackingCounter = 0;
        this.olGeoLocation.setTracking(false);
        this.autoCompleteMsg = autoCompleteMsgByDefault;
        this.olGeolocationMapLayer.setVisible(false);
      } else {
        this.search = null;
        this.gpsTrackingEnabled = true;
        this.olGeoLocation.setTracking(true);
        this.autoCompleteMsg = autoCompleteMsgByDefault;
        if (!isNullOrUndefined(this.olGeolocationMapLayer)) {
          this.olGeolocationMapLayer.setVisible(true);
        }
      }
    },
    toggleLayerSwitcher() {
      log.t(`# toggleLayerSwitcher this.layerSwitcherVisible : ${this.layerSwitcherVisible}`);
      if (this.layerSwitcherVisible) {
        // this.layerSwitcherVisible = false;
        // this.olmap.myref2LayerSwitcher.hidePanel();
      } else {
        this.layerSwitcherVisible = true;
        // this.olmap.myref2LayerSwitcher.showPanel();
      }
    },
    clearItems() {
      log.t('clear');
      this.search = null;
      this.entries = [];
    },
    getVisibleLayers() {
      log.t('getVisibleLayers');
      this.olmap.getLayers()
        .forEach((layer) => {
          const type = isNullOrUndefined(layer.get('type')) ? layer.type : layer.get('type');
          const source = layer.getSource();
          if (functionExist(source.getParams)) {
            const sourceParams = source.getParams();
            const sourceLayers = isNullOrUndefined(sourceParams) ? 'NULL' : sourceParams.LAYERS;
            log.w(`layers : ${sourceLayers} [${type}]
        title : ${layer.get('title')}
        isvisible: ${layer.get('visible')}`, layer, source);
          } else {
            log.w(`title : ${layer.get('title')} [${type}]
                  isvisible: ${layer.get('visible')}`, layer, source);
          }
        });
    },
    setBaseLayer(baseLayerName) {
      log.t(`setBaseLayer(${baseLayerName})`);
      let isBaseLayerNameFound = false;
      this.olmap.getLayers()
        .forEach((layer) => {
          const type = isNullOrUndefined(layer.get('type')) ? layer.type : layer.get('type');
          const source = layer.getSource();
          if (type === 'base') {
            const currentBaseLayer = source.getLayer();
            if (currentBaseLayer === baseLayerName) {
              layer.setVisible(true);
              isBaseLayerNameFound = true;
            } else {
              layer.setVisible(false);
            }
            log.w(`layers : ${currentBaseLayer} [${type}]
                 title : ${layer.get('title')}
                 isvisible: ${layer.get('visible')}`, layer, source);
          }
        });
      if (!isBaseLayerNameFound) {
        log.w(`WARNING : The layer ${baseLayerName} was not found ! SETTING fonds_geo_osm_bdcad_couleur TO VISIBLE `);
        this.setBaseLayer('fonds_geo_osm_bdcad_couleur');
      }
      const divToc = getEl('divLayerSwitcher');
      LayerSwitcher.renderPanel(this.olmap, divToc);
    },
    loadLayerLimiteLausanne(fitToLayer = false) {
      log.t('In loadLayerLimiteLausanne ');
      const olMap = this.olmap;
      const layerName = 'limiteLausanne';
      const olLayer = getLayerByName(olMap, layerName);
      if (isNullOrUndefined(olLayer)) {
        // layer was not yet created so just do it
        log.t(`In loadSectorsPolygonLayer creating ${layerName}`);
        const vectorSource = getVectorSourceGeoJson(limiteLausanne, true);
        const newVectorLayer = new OlLayerVector({
          // title: 'Limite Lausanne', //commented to suppress from layerswitcher
          visible: true,
          type: 'limite',
          name: layerName,
          source: vectorSource,
          style: getPolygonStyle,
        });
        olMap.addLayer(newVectorLayer);
        if (fitToLayer) {
          const extent = newVectorLayer.getSource().getExtent();
          olMap.getView().fit(extent, olMap.getSize());
        }
      }
      log.l(`End of loadLayerLimiteLausanne  ${layerName} is loaded`);
    },
  },

};

/*
curl 'https://map.lausanne.ch/mapserv_proxy?
ogcserver=source+for+image/png
&SERVICE=WMS
&VERSION=1.3.0
&REQUEST=GetFeatureInfo
&FORMAT=image%2Fpng
&TRANSPARENT=true
&QUERY_LAYERS=
    envconst_arbres_public_msgroup
  %2Cplanville_zones_chiens
  %2Cplanville_zones_chiens_forets
  %2Cplanville_wc_public
  %2Cplanville_gofontaine
  %2Cbdcad_cs_bati_pol
&LAYERS=
  envconst_arbres_public_msgroup
  %2Cplanville_zones_chiens
  %2Cplanville_zones_chiens_forets
  %2Cplanville_wc_public
  %2Cplanville_gofontaine
  %2Cbdcad_cs_bati_pol
&INFO_FORMAT=application%2Fgeojson
&I=50
&J=50
&CRS=EPSG%3A21781
&STYLES=
&WIDTH=101
&HEIGHT=101
&BBOX=538192.4962838745%2C152368.23628387452%2C538212.7237161255%2C152388.4637161255'
-H 'authority: map.lausanne.ch'
-H 'sec-ch-ua: ";Not A Brand";v="99", "Chromium";v="94"'
-H 'accept: application/json, text/plain, *!/!*'
-H 'sec-ch-ua-mobile: ?0'
-H 'sec-ch-ua-platform: "Linux"'
-H 'origin: https://smartmap.lausanne.ch'
-H 'sec-fetch-site: same-site'
-H 'sec-fetch-mode: cors'
-H 'sec-fetch-dest: empty'
-H 'referer: https://smartmap.lausanne.ch/'
-H 'accept-language: en-US,en;q=0.9,fr-CH;q=0.8,fr;q=0.7,fr-FR;q=0.6,es;q=0.5'
OUTPUT of this curl:
{
 "features": [
   {
    "type": "Feature",
    "id": 98257,
    "properties": {
    "type": "Fontaine - Lausanne - Place St-François, au nord de l&#39;église, Eau potable, Ouvert"
     }
   }
 ]
}
####END_OF_LAYER####
*/


</script>
